import{a as e}from"../chunk-LNZLWPO6.js";var i=t=>e.test(t),a=i;export{a as default};
//# sourceMappingURL=isValidEmail.js.map